import { useSuspenseQuery } from '@tanstack/react-query'
import { sajuQueryKeys } from './queryKeys'
import { sajuApi } from './sajuApi'

export function useReadingHistoryQuery(sajuType: string) {
  return useSuspenseQuery({
    queryKey: sajuQueryKeys.readingHistory(sajuType),
    queryFn: () => sajuApi.readingHistory(sajuType),
  })
}
